import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const ResultadoDiv = styled.div`
    color: #fff;
    font-family: 'Bebas Neue', cursive;
    text-align: center;
`;

const Info = styled.p`
    font-size: 18px;

    span{
        font-weight: bold;
    }
`;

const Precio = styled.p`
    font-size: 26px;

    span{
        font-weight: bold;
    }
`;

const Cotizacion = ({resultado}) => {
    if(Object.keys(resultado).length === 0) return null;

    return ( 
        <ResultadoDiv>
            <Precio>El precio es: <span>{resultado.PRICE}</span></Precio>
            <Info>Valor Máx. Día: <span>{resultado.HIGHDAY}</span></Info>
            <Info>Valor Min. Día: <span>{resultado.LOWDAY}</span></Info>
            <Info>Var. Ult 24hs: <span>{resultado.CHANGEPCT24HOUR}%</span></Info>
            <Info>Ult. Actualizacion: <span>{resultado.LASTUPDATE}</span></Info>
        </ResultadoDiv>
     );
}

Cotizacion.propTypes = {
    resultado: PropTypes.object.isRequired
}

export default Cotizacion;